import React from "react";
import { useApp } from "../context/AppContext";

const PaymentCancel: React.FC = () => {
  const { state, dispatch } = useApp();

  const handleBackToApp = () => {
    const initialScreen = state.user?.role === "normal" ? "main" : "main-provider";
    dispatch({ type: "SET_SCREEN", payload: initialScreen });
    // Change URL to root to trigger main screen render
    window.history.pushState({}, "", "/");
    // Force re-render by changing location
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        <div className="payment-result-icon payment-result-icon-error">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#dc2626"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 className="payment-result-title">Payment Cancelled</h1>

        <p className="payment-result-message">
          You cancelled the payment process. No charges were made to your account.
        </p>

        <div className="payment-result-info">
          <p>
            💡 You can still browse therapist recommendations with limited information. Upgrade anytime to unlock full profiles!
          </p>
        </div>

        <div className="payment-result-actions">
          <button
            onClick={handleBackToApp}
            className="payment-result-button payment-result-button-primary"
          >
            Back to VocreaAI
          </button>

          <button
            onClick={() => window.history.back()}
            className="payment-result-button payment-result-button-secondary"
          >
            Try Payment Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
